import HomeTermsAndConditionsPage from './HomeTermsAndConditionsPage';

export default HomeTermsAndConditionsPage;
